import animateSeq1 from 'assets/animation/home_main.json'
import animateSeq2 from 'assets/animation/home_passive.json'
import { Component } from 'react'
import Lottie from 'react-lottie'

export default class HomeAnimation extends Component {

  state = {
    direction: 1,
    sequenceIndex: 1,
  }

  render() {

    const defaultOptions = {
      loop: this.state.sequenceIndex===2,
      autoplay: true,
      animationData: this.state.sequenceIndex===1 ? animateSeq1 : animateSeq2,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    }

    return <div id="home-screen-animation">
      <Lottie
        options={defaultOptions}
        width={"80%"}
        direction={this.state.direction}
        isStopped={this.state.isStopped}
        isPaused={this.state.isPaused}
        eventListeners={[
          {
            eventName: 'complete',
            callback: (e) => {

              // Main sequence once
              if (this.state.sequenceIndex===1) {
                this.setState({ sequenceIndex: 2 })
                return
              }
            },
          },
        ]}
      />
    </div>
  }
}
